import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/search';
import { Observable } from 'rxjs/Observable';
import { ListItem } from '../../core/models/list-item';
import { DocumentDetail } from '../models/document-detail';
import * as fromDoc from '../../document/reducers';
import * as fromCore from '../../core/reducers';
import * as docActions from '../../document/actions/document';
import { DocumentInfo } from '../../document/models/document-info';

@Component({
  selector: 'app-admin-document-manager',
  template: `
  <irar-file-upload
      [uploading]="uploading$ | async"
      [progress]="progress$ | async"
      [documentData]="documentData$ | async"
      (uploadFile)="upload($event)"></irar-file-upload>
    <irar-document-edit-form
      [loading]="loading$ | async"
      [sites]="sites$ | async"
      [authors]="authors$ | async"
      [documentData]="documentData$ | async"
      [farms]="farms$ | async"
      (upsert)="upsertMetaData($event)"
      (delete)="deleteDocument($event)"></irar-document-edit-form>
  `
})
export class AdminDocumentsContainerComponent {
  documentId: number;
  loading$: Observable<boolean>;
  farms$: Observable<ListItem[]>;
  sites$: Observable<ListItem[]>;
  authors$: Observable<string[]>;
  uploading$: Observable<boolean>;
  progress$: Observable<number>;
  documentData$: Observable<DocumentDetail>;

  constructor(private route: ActivatedRoute,
    private store: Store<fromRoot.State>,
    private docStore: Store<fromDoc.State>) {
    this.loading$ = this.store.select(fromRoot.getSearchLoading);
    this.farms$ = this.store.select(fromRoot.getFarms);
    this.sites$ = this.store.select(fromRoot.getSites);
    this.authors$ = this.store.select(fromRoot.getAuthors);
    this.documentData$ = this.store.select(fromRoot.getDocumentDetail);
    this.uploading$ = this.store.select(fromDoc.getDocumentUploading);
    this.progress$ = this.docStore.select(fromCore.getProgress);
    if (!isNaN(this.route.snapshot.params['id'])) {
      this.documentId = +this.route.snapshot.params['id'];
      this.store.dispatch(new actions.LoadDocumentDetailAction(this.documentId));
    } else {
      this.documentId = 0;
      this.store.dispatch(new actions.ClearDocumentDetailAction());
    }
  }

  upsertMetaData (e: DocumentDetail) {
    this.store.dispatch(new actions.UpsertDocumentMetadataAction(e));
  }

  upload(e: DocumentInfo) {
    this.docStore.dispatch(new docActions.UploadFileAction(e));
  }

  deleteDocument(id: number) {
    this.store.dispatch(new docActions.RemoveDocumentAction(id));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/admin-documents.ts